import { render, staticRenderFns } from "./PriceSensitivity.vue?vue&type=template&id=672de89e&scoped=true&lang=pug&"
import script from "./PriceSensitivity.vue?vue&type=script&lang=js&"
export * from "./PriceSensitivity.vue?vue&type=script&lang=js&"
import style0 from "./PriceSensitivity.vue?vue&type=style&index=0&id=672de89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672de89e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow,VSlider})
